<template>
    <div class="queue__info">
        <div class="queue__item-avatar">
            <img class="img-thumbnail" :src="getAvatar()">
        </div>
        <div class="queue__item-description">
            <span class="queue__item-number float-right">
                {{ user.number }}
            </span>
            <div class="queue__item-name">
                {{ user.name }}
            </div>
            <div class="queue__item-contact">
                <b>Student Number:</b> {{ user.emplid }}, <b>Western Email:</b> {{ user.emailid }}
            </div>
            <div class="queue__item-checkin">
                <b>Check-in:</b> {{ getLocalTime }}
            </div>
            <div
                :class="['queue__item-appointmenttype', !user.appointmentType ? 'queue__item-appointmenttype--unassigned' : 'queue__item-appointmenttype--assigned']">
                <b>Appointment Type:</b> {{ getAppointmentType }}
            </div>
            <div
                :class="['queue__item-counsellor', !user.counsellor ? 'queue__item-counsellor--unassigned' : 'queue__item-counsellor--assigned']">
                <b>Counsellor:</b> {{ getCounsellor }}
            </div>
            <div
                :class="['queue__item-waitingarea', !user.waitingArea ? 'queue__item-waitingarea--unassigned' : 'queue__item-waitingarea--assigned']">
                <b>Waiting Area:</b> {{ getWaitingArea }}
            </div>
            <div class="queue__item-action">
                <span class="btn-tooltip mr-2" data-toggle="tooltip" data-placement="bottom" title="Dequeue">
                    <button type="button" class="btn btn-icon btn-sm btn-light-success" data-toggle="modal"
                        :data-target="'#' + getQueueId">
                        <i class="far fa-check"></i>
                    </button>
                </span>
                <span class="btn-tooltip mr-2" data-toggle="tooltip" data-placement="bottom" title="Send Notification">
                    <button type="button" class="btn btn-icon btn-sm btn-light-success" data-toggle="modal"
                        :data-target="'#' + getNotifyId" @click="getNotificationSetting()">
                        <i class="fas fa-bell"></i>
                    </button>
                </span>
                <span class="btn-tooltip mr-2" data-toggle="tooltip" data-placement="bottom" title="Edit">
                    <button type="button" class="btn btn-icon btn-sm btn-light-primary" @click="editItem()">
                        <i class="far fa-user-edit"></i>
                    </button>
                </span>
                <span v-if="user.triageData" class="btn-tooltip mr-2" data-toggle="tooltip" data-placement="bottom"
                    title="View Triage Information">
                    <button type="button" class="btn btn-icon btn-sm btn-light-primary" data-toggle="modal"
                        :data-target="'#' + getViewId">
                        <i class="fas fa-file-alt"></i>
                    </button>
                </span>
                <span class="btn-tooltip" data-toggle="tooltip" data-placement="bottom" title="Remove">
                    <button type="button" class="btn btn-icon btn-sm btn-light-danger" data-toggle="modal"
                        :data-target="'#' + getRemoveId"><i class="far fa-trash"></i></button>
                </span>
            </div>
        </div>
        <!-- Dequeue -->
        <div class="modal fade" :id="getQueueId" tabindex="-1" role="dialog" aria-labelledby="dequeueItem"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="dequeueItem">Dequeue Item</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <i class="far fa-check-square fa-2x icon__success"></i>
                        <span v-if="user.name">
                            You are about to <b>process</b> the queue item
                            for <b>{{ user.name }}</b>. Please click the <b>confirm</b> button to
                            proceed.
                        </span>
                        <span v-else>
                            You are about to <b>process</b> this queue item. Please click the <b>confirm</b> button to
                            proceed.
                        </span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
                            @click="dequeueItem">Confirm</button>
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Notification-->
        <div class="modal fade" :id="getNotifyId" tabindex="-1" role="dialog" aria-labelledby="itemNotifyForm"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="itemNotifyForm">Send Notification</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="notificationStatus == 'sent'" class="alert alert-success" role="alert">
                            <i class="fas fa-check"></i> The notification has been successfully sent!
                        </div>
                        <div v-else-if="notificationStatus == 'warning'" class="alert alert-warning" role="alert">
                            <i class="fas fa-exclamation-circle"></i> A counsellor must be assigned to the queue item in
                            order to send a notification.
                        </div>
                        <div v-else-if="notificationStatus == 'error'" class="alert alert-danger" role="alert">
                            <i class="fas fa-exclamation-triangle"></i> The notification could not be sent. Please
                            contact
                            your system admninistrator.
                        </div>
                        <form :id="getNotifyFormId">
                            <div class="form-group">
                                <label for="notificationType" class="font-weight-bold">Notification Type</label>
                                <select v-model="notification.notificationType"
                                    :class="notificationTypeValid == true ? 'form-control' : 'form-control is-invalid'"
                                    id="notificationType" :disabled="notificationStatus == 'loading'"
                                    @change="setNotification()">
                                    <option value="" disabled>Please select...
                                    </option>
                                    <option v-for="(item, i) in notificationTypes" :key="i"
                                        :value="item.notificationType">
                                        {{ item.notificationType }}</option>
                                    <option value="Other">Other</option>
                                </select>
                                <div v-if="!notificationTypeValid" class="invalid-feedback">
                                    Please select a valid notification.
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="notificationSubject" class="font-weight-bold">Notification Subject</label>
                                <div v-if="notification.notificationType == 'Other'" class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><small>King's ADO Digital Check-in:</small></div>
                                    </div>
                                    <input v-model="notification.subject"
                                        :disabled="notification.notificationType != 'Other'"
                                        :class="notificationSubjectValid == true ? 'form-control' : 'form-control is-invalid'"
                                        id="notificationSubject" placeholder="Please provide a notification subject">
                                </div>
                                <input v-else v-model="notification.subject"
                                    :disabled="notification.notificationType != 'Other'"
                                    :class="notificationSubjectValid == true ? 'form-control' : 'form-control is-invalid'"
                                    id="notificationSubject" placeholder="Please provide a notification subject">
                                <div v-if="!notificationSubjectValid" class="invalid-feedback">
                                    Please provide a valid notification subject.
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="notificationMessage" class="font-weight-bold">Notification Message</label>
                                <textarea v-model="notification.message"
                                    :disabled="notification.notificationType != 'Other'"
                                    :class="notificationMessageValid == true ? 'form-control' : 'form-control is-invalid'"
                                    id="notificationMessage" rows="10"
                                    placeholder="Please provide a notification message"></textarea>
                                <div v-if="!notificationMessageValid" class="invalid-feedback">
                                    Please provide a valid notification message.
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button v-if="notificationStatus == 'submit'" type="button" class="btn btn-sm btn-success"
                            disabled>Sending <i class="fas fa-spinner fa-spin"></i></button>
                        <button v-else-if="notificationStatus == 'sent'" type="button" class="btn btn-sm btn-success"
                            disabled>Sent <i class="fas fa-check"></i></button>
                        <button v-else-if="notificationStatus == 'loading'" type="button" class="btn btn-sm btn-primary"
                            disabled>Loading <i class="fas fa-spinner fa-spin"></i></button>
                        <button v-else-if="notificationStatus == 'warning' || notificationStatus == 'error'"
                            type="button" class="btn btn-sm btn-primary" disabled>Send</button>
                        <button v-else type="button" class="btn btn-sm btn-primary"
                            @click="sendNotification()">Send</button>
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Triage form -->
        <div v-if="user.triageData" class="modal fade" :id="getViewId" tabindex="-1" role="dialog"
            aria-labelledby="itemTriageInformation" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-large" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="itemTriageInformation">Triage Information</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <triage-form-preview :triageData="user.triageData"></triage-form-preview>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Remove -->
        <div class="modal fade" :id="getRemoveId" tabindex="-1" role="dialog" aria-labelledby="dequeueItem"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="dequeueItem">Remove Queue Item</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <i class="far fa-exclamation-triangle fa-2x icon__warning"></i>
                        <span v-if="user.name">
                            You are about to remove <b>{{ user.name }}</b> from the queue.
                            Please select a reason for removing this student.
                        </span>
                        <span v-else>
                            You are about to remove this queue item from the queue. Please
                            select a reason for removing this student.
                        </span>
                        <form :id="getRemoveFormId">
                            <input type="hidden" name="id" id="id" v-model="user.itemid">
                            <input type="hidden" name="mode" id="mode" value="dequeueItem">
                            <input type="hidden" name="department" id="department" :value="getDepartment">
                            <input type="hidden" name="queueType" id="queueType" value="removed">
                            <div class="form-group mt-2 mb-0">
                                <select class="form-control form-control-sm" id="queueReason" name="queueReason">
                                    <option value="Student has left">Student has left</option>
                                    <option value="Student has not shown up">Student has not shown up</option>
                                    <option value="Long wait time">Wait time is too long</option>
                                    <option value="Referred to a different department">Referred to a different department for assistance</option>
                                </select>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
                            @click="removeItem">Confirm</button>
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import TriageFormPreview from '../Triage/TriageForm.vue';

const DEPARTMENT = `Academic Dean's Office`;

export default {
    name: 'queue-item',
    components: {
        TriageFormPreview
    },
    props: {
        counsellors: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        waitingAreasData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            notification: {
                message: '',
                notificationType: '',
                subject: ''
            },
            notificationTypes: [],
            notificationMessageValid: true,
            notificationStatus: '',
            notificationSubjectValid: true,
            notificationTypeValid: true,
            updateItemStatus: false,
        }
    },
    methods: {
        dequeueItem() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl`;
            const formData = new FormData();

            // Add form keypair values
            formData.append('id', this.user.itemid);
            formData.append('mode', 'dequeueItem');
            formData.append('department', DEPARTMENT);
            formData.append('queueType', 'dequeued');
            formData.append('queueReason', 'Completed');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Resolve success'
                if (!json.result.match(/OK/i)) {
                    // Handle failure
                    that.$emit('setNotificationMessage', {
                        message: `The queue item for ${that.user.name} could not be dequeued. Please contact your system administrator.`,
                        type: "warning"
                    });
                }

                // Refresh queue
                that.$emit('refreshQueue');
            }).catch(function (error) {
                // Handle error
                that.$emit('setNotificationMessage', {
                    message: `The queue item for ${that.user.name} could not be dequeued. Please contact your system administrator.`,
                    type: "warning"
                });

                // Refresh queue
                that.$emit('refreshQueue');
            })
        },
        editItem() {
            // Route with user ID
            this.$router.push({
                name: 'queue-edit',
                params: {
                    counsellors: this.counsellors,
                    itemId: this.user.itemid,
                    waitingAreasData: this.waitingAreasData
                }
            })
        },
        getAvatar() {
            if (this.user && this.user.photo) {
                return `data:image/jpeg;base64,` + btoa(`${this.user.photo}`);
            }

            return `../src/assets/avatar/profile.jpg`;
        },
        getNotificationSetting() {
            const that = this;
            let api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getNotificationTypes&department=${DEPARTMENT}&id=${this.user.itemid}`;

            // Reset settings
            this.resetNotification();

            // Set loader
            this.notificationStatus = 'loading';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.notificationTypes = json.data || that.notificationTypes;
                        // Set loader       
                        that.notificationStatus = '';
                    } else if (json.result.match(/^WARNING/i)) {
                        that.notificationStatus = 'warning';
                    } else {
                        that.notificationStatus = 'error';
                    }
                })
                .catch(function (error) {
                    // Set loader
                    that.notificationStatus = 'error';
                });
        },
        removeItem() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl`;
            const formRef = document.getElementById(`removeForm${this.user.itemid}`);
            const formData = new FormData(formRef);

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Success
                if (!json.result.match(/^OK/i)) {
                    // Handle failure
                    that.$emit('setNotificationMessage', {
                        message: `The queue item for ${that.user.name} could not be removed. Please contact your system administrator.`,
                        type: "warning"
                    });
                }

                // Refresh queue
                that.$emit('refreshQueue');
            }).catch(function (error) {
                // Handle failure
                that.$emit('setNotificationMessage', {
                    message: `The queue item for ${that.user.name} could not be removed. Please contact your system administrator.`,
                    type: "warning"
                });

                // Refresh queue
                that.$emit('refreshQueue');
            })
        },
        resetNotification() {
            // Reset notification
            this.notification = {
                message: '',
                notificationType: '',
                subject: ''
            };
            this.notificationMessageValid = true;
            this.notificationSubjectValid = true;
            this.notificationStatus = '';
            this.notificationTypeValid = true;
        },
        sendNotification() {
            if (this.validateNotification()) {
                const that = this;
                const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?sendNotification`;
                const formData = new FormData();

                // Add form keypair values
                formData.append('department', DEPARTMENT);
                formData.append('id', this.user.itemid);
                formData.append('message', this.notification.message);
                formData.append('mode', 'sendNotification');
                formData.append('notificationType', this.notification.notificationType);
                formData.append('subject', this.notification.notificationType == "Other" ? `King's ADO Digital Check-in: ${this.notification.subject}` : this.notification.subject);

                // Submit status
                this.notificationStatus = 'submit';

                // POST request
                fetch(api, {
                    method: 'POST',
                    body: formData
                }).then(function (response) {
                    return response.json();
                }).then(function (json) {
                    // Success
                    if (json.result.match(/^OK/i)) {
                        that.notificationStatus = 'sent';
                    } else {
                        that.notificationStatus = 'error';
                    }
                }).catch(function () {
                    that.notificationStatus = 'error';
                })
            }
        },
        setNotification() {
            // Check for other
            if (this.notification.notificationType == "Other") {
                this.notification.message = '';
                this.notification.subject = '';
            } else {
                for (let i = 0; i < this.notificationTypes.length; i++) {
                    if (this.notificationTypes[i].notificationType == this.notification.notificationType) {
                        this.notification.message = this.notificationTypes[i].message;
                        this.notification.subject = this.notificationTypes[i].subject;
                        break;
                    }
                }
            }
        },
        validateNotification() {
            let valid = true

            // Validate notification form
            this.notificationMessageValid = this.notification.message && this.notification.message.length >= 2 ? true : false;
            this.notificationSubjectValid = this.notification.subject && this.notification.subject.length >= 2 ? true : false;
            this.notificationTypeValid = this.notification.notificationType && this.notification.notificationType != "" ? true : false;

            // Validate form
            if (!this.notificationMessageValid || !this.notificationSubjectValid || !this.notificationTypeValid) {
                valid = false;
            } else {
                valid = true;
            }

            return valid;
        }
    },
    computed: {
        getAppointmentType() {
            if (this.user.appointmentType && this.user.appointmentType == "inperson") {
                return 'In-person';
            }

            if (this.user.appointmentType && this.user.appointmentType == "virtual") {
                return 'Virtual';
            }

            return 'Not specified';
        },
        getCounsellor() {
            const assignedCounsellor = this.user.counsellor;
            let counsellor;

            // Find counsellor
            if (assignedCounsellor) {
                counsellor = this.counsellors.find(function (counsellor) {
                    return counsellor.username.match(assignedCounsellor);
                });

                if (counsellor && counsellor.commonName) {
                    return counsellor.commonName;
                }
            }

            return 'Not assigned';
        },
        getDepartment() {
            return DEPARTMENT;
        },
        getLocalTime() {
            let timestamp = this.user.timestampCheckin * 1000;
            let date = new Date(timestamp);

            return date.toLocaleString();
        },
        getNotifyId() {
            return `notify${this.user.itemid}`;
        },
        getNotifyFormId() {
            return `notifyForm${this.user.itemid}`;
        },
        getQueueId() {
            return `queue${this.user.itemid}`;
        },
        getRemoveId() {
            return `remove${this.user.itemid}`;
        },
        getRemoveFormId() {
            return `removeForm${this.user.itemid}`;
        },
        getViewId() {
            return `view${this.user.itemid}`;
        },
        getWaitingArea() {
            return this.user.waitingArea || 'Not assigned';
        }
    },
    mounted() {
        // Tooltip inialization
        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover'
        })

        $('[data-toggle="tooltip"]').on('click', function () {
            $(this).tooltip('hide')
        })
    }
}
</script>

<style scoped>
.icon__success {
    color: #0abb87;
}

.modal-dialog-large {
    max-width: 992px !important;
}

.modal-body {
    font-size: 14px;
}

.modal-title {
    font-weight: 600;
    font-size: 1rem;
    color: #48465b;
}

.queue__item-action {
    margin-top: .5rem;
}

.queue__item-avatar {
    float: left;
    padding-right: 1rem;
    padding-top: 6px;
}

.queue__item-avatar img {
    object-fit: cover;
    width: 96px;
    height: 96px;
}

.queue__item-checkin,
.queue__item-contact {
    font-size: 14px;
    margin: 0;
    color: #74788d;
}

.queue__item-appointmenttype {
    font-size: 14px;
    margin-top: .25rem;
}

.queue__item-appointmenttype--assigned {
    color: #0abb87;
}

.queue__item-appointmenttype--unassigned {
    color: #ffb822;
}

.queue__item-counsellor {
    font-size: 14px;
}

.queue__item-counsellor--assigned {
    color: #5578eb;
}

.queue__item-counsellor--unassigned {
    color: #ffb822;
}

.queue__item-description {
    padding-left: 112px;
}

.queue__item-name {
    font-weight: 700;
    font-size: 16px;
    color: #48465b;
    -webkit-transition: color 0.3s ease;
    transition: color 0.3s ease;
}

.queue__item-number {
    color: #fd397a;
    font-size: 1.25rem;
    font-weight: 600;
}

.queue__item-waitingarea {
    font-size: 14px;
}

.queue__item-waitingarea--assigned {
    color: #fd397a;
}

.queue__item-waitingarea--unassigned {
    color: #ffb822;
}
</style>